<template>
  <div class="footer" :style="{'background':backgroundColor}">
    <div class="inner">
      <div class="top">
        <div class="company">
          <div class="introduce">
            <img class="logo" src="../../assets/img/logo.png" alt="">
            <div class="tit">赢链通官网</div>
          </div>
          <div class="intro">为中小微企业、乃至一些个体经营户解决融资难题</div>
        </div>
        <ul class="txt-wrap">
          <li class="tit">关于赢链通</li>
          <li @click="jump('about')">公司介绍</li>
          <li @click="jump('team')">管队管理</li>
        </ul>
        <ul class="txt-wrap">
          <li class="tit">业务合作</li>
          <li @click="jump('cooperation')">合作伙伴</li>
        </ul>
      </div>
      <div class="bom">
        <p>Email：<a href="mailto:yuhaotian@caiqilin.com" target="_blank">yuhaotian@caiqilin.com</a></p>
        <p>地址：北京市朝阳区朝阳公园南路1号2幢2层201内215</p>
        <p>© 2014-2022 北京京融科技有限公司 ying-link.com 版权所有</p>
        <p><a href="https://beian.miit.gov.cn" target="_blank">京ICP备20019032号-3</a></p>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data(){
      return{

      }
    },
    props:['backgroundColor'],
    methods:{
      jump(page){
        if(page){
          this.$router.push({
            path: `/${page}`
          });
        }
      }
    }
  }
</script>
<style lang="less" scoped>
.footer{
  width:100%;
  background:#060a15;
  .inner{
    width:1280px;
    margin:0 auto;
    padding:60px 0;
  }
  .top{
    display: flex;
    justify-content: space-around;
    padding-bottom:34px;
    border-bottom:1px solid #888B97;
    .company{
      .introduce{
        display: flex;
        align-items: center;
        .logo{
          width:33px;
          height:33px;
          overflow: hidden;
        }
        .tit{
          font-family: Hiragino Sans GB;
          font-style: normal;
          font-weight: bold;
          font-size: 20px;
          color: #fff;
          margin-left:10px;
        }
      }
      .intro{
        margin-top:10px;
        font-family: PingFang HK;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 24px;
        color: #C4C4C4;
        width:322px;
        text-align: justify;
      }
    }
    .txt-wrap{
      .tit{
        font-family: PingFang HK;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 25px;
        text-transform: capitalize;
        color: #fff;
        margin-bottom:22px;
        cursor:default;
        &:hover{
          color:#fff;
        }
      }
      li{
        font-family: PingFang HK;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        text-transform: capitalize;
        color: #888B97;
        margin-bottom:16px;
        cursor: pointer;
        &:hover{
          color:#356EF8;
        }
      }
    }
    .ewm-wrap{
      margin-left:35px;
      .tit{
        font-family: PingFang HK;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 25px;
        text-transform: capitalize;
        color: #0E1735;
        text-align: center;
      }
      img{
        width:106px;
        height:107px;
        overflow: hidden;
        display: block;
        margin-top:12px;
      }
    }
    .applet{
      margin-left:100px;
    }
  }
  .bom{
    padding-top:36px;
    p{
      font-family: PingFang HK;
      font-style: normal;
      font-size: 14px;
      line-height: 32px;
      text-align: center;
      color: #C4C4C4;
      text-align: center;
      a{
        color: #C4C4C4;
        &:hover{
          color:#356EF8;
        }
      }
    }
  }
}
</style>